import { map } from 'lodash';

interface ToMediaArgs {
    w: number;
    h: number;
}

export const toMediaUrl = (mediaHost: string, url: string, args: ToMediaArgs): string => {
    let mediaUrl = `${mediaHost}/media`;
    const queryString = map(args, (v, k) => {
        return `${encodeURIComponent(k)}=${encodeURIComponent(v)}`;
    }).join('&');

    mediaUrl += `?u=${encodeURIComponent(url)}`;

    if (queryString) {
        mediaUrl += `&${queryString}`;
    }

    return mediaUrl;
};

export const fromMediaUrl = (mediaHost: string, url: string): string => {
    const mediaUrl = `${mediaHost}/media`;
    const match = /[?&]u=([^&]*)/.exec(url);

    if (url.search(mediaUrl) === -1) {
        return url;
    }

    if (!match) {
        return url;
    }

    return decodeURIComponent(match[1]);
};
